import type { ReactNode } from "react";

/**
 * The centred card layout every pre-portal page shares: sign-in, the first
 * welcome, the customer chooser, being turned away, a blocked customer. None
 * has portal navigation, because the person has no customer to navigate yet.
 */
export function PortalSignInShell({
  title,
  subtitle,
  children,
  footer,
  eyebrow = "Pollards",
}: {
  /** The line above the title: the brand, or the customer a page is about. */
  eyebrow?: string;
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
  /** Outside the shell's flow, e.g. the review bar. */
  footer?: ReactNode;
}) {
  return (
    <div className="flex min-h-screen flex-col bg-muted/40">
      <div className="flex flex-1 items-center justify-center px-4 py-10">
        <div className="w-full max-w-md space-y-4">
          <div className="space-y-1 text-center">
            <p className="text-sm font-semibold tracking-tight">{eyebrow}</p>
            <h1 className="text-xl font-semibold tracking-tight">{title}</h1>
            {subtitle && (
              <p className="text-sm text-muted-foreground">{subtitle}</p>
            )}
          </div>
          {children}
        </div>
      </div>
      {footer}
    </div>
  );
}
